const Stories = [
  {
    image: '/story1.jpg',
  },
  {
    image: '/story2.jpg',
  },
  {
    image: '/story3.jpg',
  },
];

export default Stories;
